import { oz } from '@weft/utils';
import { PeriodSchema } from '../../primitives';
import { withNullAsOptional } from '../../utils/literal-transforms';
import { NewLineItemProductVariantMeterSchema } from '../line-item-product-variant-meter/new-line-item-product-variant-meter-schema';
import { PricingSchema } from '../pricing/pricing-schema';
import { ProductSettingsSchema } from '../product-variant/fixed-product-variants/product-settings-schemas';

export const NewLineItemProductVariantSchema = oz.object({
  productVariantId: withNullAsOptional(oz.string()),
  name: oz.string(),
  description: withNullAsOptional(oz.string()),
  pricing: PricingSchema,
  periodLimit: PeriodSchema.optional(),
  settings: withNullAsOptional(ProductSettingsSchema),
  meter: withNullAsOptional(NewLineItemProductVariantMeterSchema),
}).openapi('NewLineItemProductVariant');

export type NewLineItemProductVariant = oz.infer<typeof NewLineItemProductVariantSchema>;